import React from "react";

import OverView from "./OverView";
// import RevenueByLocation from "./RevenueByLocation";

import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Dashboard = () => {
  document.title = "Dashboard | Clued.in Cloest Admin";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Clued.in Closet" breadcrumbItem="Dashboard" />
          <Row className="mb-4">
            <OverView />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
